import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import gql from "graphql-tag"

const mutation = gql`
  mutation CreateMagicLogin($identifier: String!) {
    createMagicLogin(identifier: $identifier) {
      uuid
      expires {
        nanos
        seconds
      }
      resend {
        nanos
        seconds
      }
      digits
    }
  }
`

export const createMagicLoginKey = getQueryNames(mutation)[0]

export default mutation
